/* eslint-disable */
import React from 'react';
import {
  Box,
  Heading,
  Grid,
  GridItem,
  Input,
  Stack,
  Checkbox,
  FormControl,
  FormLabel,
  FormErrorMessage,
  Text,
} from '@chakra-ui/react';

function Step4ContactDetails({ form, setForm, showErrors = false }) {
  return (
    <Box maxW="100%" overflow="hidden">
      <Heading size="md" mb={{ base: 3, md: 4 }}>Contact Details</Heading>

      {/* Contact Information */}
      <Grid templateColumns={{ base: '1fr', md: '1fr 1fr' }} gap={{ base: 3, md: 4 }} mb={{ base: 5, md: 6 }}>
        {/* Row 1: First Name and Last Name */}
        <FormControl isRequired isInvalid={showErrors && !form.firstName}>
          <FormLabel fontWeight="500" fontSize="sm" color="gray.700" mb="2">
            First Name
          </FormLabel>
          <Input
            placeholder="First name *"
            value={form.firstName}
            onChange={(e) => setForm((f) => ({ ...f, firstName: e.target.value }))}
          />
          <FormErrorMessage>First name is required</FormErrorMessage>
        </FormControl>
        <FormControl isRequired isInvalid={showErrors && !form.lastName}>
          <FormLabel fontWeight="500" fontSize="sm" color="gray.700" mb="2">
            Last Name
          </FormLabel>
          <Input
            placeholder="Last name *"
            value={form.lastName}
            onChange={(e) => setForm((f) => ({ ...f, lastName: e.target.value }))}
          />
          <FormErrorMessage>Last name is required</FormErrorMessage>
        </FormControl>

        {/* Row 2: Address (full width) */}
        <GridItem colSpan={{ base: 1, md: 2 }}>
          <Input
            placeholder="Address"
            value={form.address || ''}
            onChange={(e) => setForm((f) => ({ ...f, address: e.target.value }))}
          />
        </GridItem>

        {/* Row 3: Email and Mobile */}
        <FormControl isRequired isInvalid={showErrors && !form.email}>
          <FormLabel fontWeight="500" fontSize="sm" color="gray.700" mb="2">
            Email Address
          </FormLabel>
          <Input
            placeholder="Email Address"
            type="email"
            value={form.email}
            onChange={(e) => setForm((f) => ({ ...f, email: e.target.value }))}
          />
          <FormErrorMessage>Email is required</FormErrorMessage>
        </FormControl>
        <FormControl isRequired isInvalid={showErrors && !form.mobile}>
          <FormLabel fontWeight="500" fontSize="sm" color="gray.700" mb="2">
            Mobile number
          </FormLabel>
          <Input
            placeholder="Mobile number *"
            type="tel"
            value={form.mobile}
            onChange={(e) => setForm((f) => ({ ...f, mobile: e.target.value }))}
          />
          <FormErrorMessage>Mobile number is required</FormErrorMessage>
        </FormControl>

        {/* Row 4: Eircode */}
        <FormControl isRequired isInvalid={showErrors && !form.eirCode}>
          <FormLabel fontWeight="500" fontSize="sm" color="gray.700" mb="2">
            Eircode
          </FormLabel>
          <Input
            placeholder="Eircode *"
            value={form.eirCode || ''}
            onChange={(e) => setForm((f) => ({ ...f, eirCode: e.target.value }))}
          />
          <FormErrorMessage>Eircode is required</FormErrorMessage>
        </FormControl>
      </Grid>

      {/* Preferences and Consent */}
      <Stack spacing={{ base: 3, md: 2 }}>
        <Checkbox
          alignItems="flex-start"
          isChecked={form.marketingOptIn}
          onChange={(e) => setForm((f) => ({ ...f, marketingOptIn: e.target.checked }))}
        >
          <Text as="span" wordBreak="break-word" overflowWrap="anywhere" lineHeight="1.4">
            I dont mind marketing messages
          </Text>
        </Checkbox>
      </Stack>
    </Box>
  );
}

export default Step4ContactDetails;
